import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-power",
  "use": "icon-power-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-power\" id=\"icon-power\"><path d=\"M18.36 6.64a9 9 0 1 1-12.73 0\" /><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol